import {getRouteApi} from "@tanstack/react-router";

export const materialFunctionsRouteApi = getRouteApi("/_app/engineering/materials/functions/");
